var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "span",
    _vm._l(_vm.templateNames, function(name) {
      return _c("span", { key: name, staticClass: "badge badge-info mr-1" }, [
        _c("i", { staticClass: "fa fa-tag fa-xs mr-1" }),
        _vm._v("\n    " + _vm._s(name) + "\n  ")
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }